
import fetch from 'lib/fetch'

export const REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID = 'REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID'
export const REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR = 'REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR'
export const RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID = 'RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID'
export const RECEIPT_PAGE_LOAD = 'RECEIPT_PAGE_LOAD'

export const receiptPageLoad = () => dispatch => {
  dispatch({ type: RECEIPT_PAGE_LOAD })
  window.analytics.page('Receipt')
}

export const fetchBillingChargeByWorkspaceSlugAndChargeId = (workspaceSlug, chargeId) => ({
  types: {
    request: REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID,
    receive: RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID,
    failure: REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR
  },
  payload: { workspaceSlug, chargeId },
  callAPI () {
    return fetch(`/api/workspaces/${workspaceSlug}/billing/charges/${chargeId}`)
      .then(res => {
        if (!res.ok) {
          throw new Error('Unable to fetch charge')
        }
        return res.json()
      })
  }
})



// WEBPACK FOOTER //
// ./actions/receipt.js